<div class="hero-actions">
  <!-- Favourite — wired to the existing favourite/watchlist capability. -->
  <button
    class="ha-btn"
    type="button"
    [class.is-active]="isFavourite"
    [disabled]="favLoading"
    (click)="toggleFavourite()"
  >
    <mat-icon class="ha-ic">{{
      isFavourite ? 'favorite' : 'favorite_border'
    }}</mat-icon>
    <span class="ha-label">{{ isFavourite ? 'Saved' : 'Save' }}</span>
  </button>

  <!-- Track plate — account-v2 followed plates. Default alerts (availability
       and price, daily digest) apply; managed from /account/followed. Stopping
       needs a second confirming click. -->
  <button
    class="ha-btn"
    type="button"
    [class.is-active]="isFollowed"
    [disabled]="followLoading"
    (click)="toggleFollow()"
  >
    <!-- Rising price line: following means tracking the plate's price and
         availability. Active state picks up the accent colour (.is-active). -->
    <mat-icon class="ha-ic">trending_up</mat-icon>
    <span class="ha-label">{{ followLabel }}</span>
  </button>

  <!-- Share — native Web Share with clipboard fallback. -->
  <button class="ha-btn" type="button" (click)="share()">
    <mat-icon class="ha-ic">{{
      shareState === 'copied' ? 'check' : 'share'
    }}</mat-icon>
    <span class="ha-label">{{ shareState === 'copied' ? 'Copied' : 'Share' }}</span>
  </button>
</div>
